var _path, _path2, _path3, _path4, _path5, _mask, _path6, _path7, _circle, _path8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTakeAPhoto(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.5 17.5L19.5 10L6.5 17.5V32L19.5 39.5L32.5 32V17.5Z",
    fill: "#087E38"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5 25V39.5L7.00028 32.2886C6.69072 32.11 6.5 31.7798 6.5 31.4224V18",
    stroke: "#2A2E3C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32.5 17.5V31.4224C32.5 31.7798 32.3093 32.11 31.9997 32.2886L19.5 39.5",
    stroke: "#2A2E3C",
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5 10L6.5 17.5L19.5 25L32.5 17.5L19.5 10Z",
    fill: "white",
    stroke: "#2A2E3C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5 22L12 14.5L14.5 13L27.5 20.5V24.5L26 24L24.5 26.5V22Z",
    fill: "#087E38",
    stroke: "#2A2E3C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-6-inside-1_2222_4249",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.1324 27C35.4299 27 34.7788 27.3686 34.4174 27.971L33.8174 28.971C33.8116 28.9807 33.8059 28.9903 33.8003 29H31C29.8954 29 29 29.8954 29 31V41C29 42.1046 29.8954 43 31 43H45C46.1046 43 47 42.1046 47 41V31C47 29.8954 46.1046 29 45 29H42.1997C42.1941 28.9903 42.1884 28.9807 42.1826 28.971L41.5826 27.971C41.2212 27.3686 40.5701 27 39.8676 27H36.1324Z"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.1324 27C35.4299 27 34.7788 27.3686 34.4174 27.971L33.8174 28.971C33.8116 28.9807 33.8059 28.9903 33.8003 29H31C29.8954 29 29 29.8954 29 31V41C29 42.1046 29.8954 43 31 43H45C46.1046 43 47 42.1046 47 41V31C47 29.8954 46.1046 29 45 29H42.1997C42.1941 28.9903 42.1884 28.9807 42.1826 28.971L41.5826 27.971C41.2212 27.3686 40.5701 27 39.8676 27H36.1324Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M34.4174 27.971L35.2749 28.4855V28.4855L34.4174 27.971ZM33.8174 28.971L34.6749 29.4855L34.6749 29.4855L33.8174 28.971ZM33.8003 29V30H34.377L34.6658 29.5009L33.8003 29ZM42.1997 29L41.3342 29.5009L41.623 30H42.1997V29ZM42.1826 28.971L43.0401 28.4565L43.0401 28.4565L42.1826 28.971ZM41.5826 27.971L42.4401 27.4565V27.4565L41.5826 27.971ZM35.2749 28.4855C35.4556 28.1843 35.7811 28 36.1324 28V26C35.0786 26 34.1021 26.5529 33.5599 27.4565L35.2749 28.4855ZM34.6749 29.4855L35.2749 28.4855L33.5599 27.4565L32.9599 28.4565L34.6749 29.4855ZM34.6658 29.5009C34.6688 29.4958 34.6718 29.4906 34.6749 29.4855L32.9599 28.4565C32.9514 28.4707 32.943 28.4849 32.9348 28.4991L34.6658 29.5009ZM31 30H33.8003V28H31V30ZM30 31C30 30.4477 30.4477 30 31 30V28C29.3431 28 28 29.3431 28 31H30ZM30 41V31H28V41H30ZM31 42C30.4477 42 30 41.5523 30 41H28C28 42.6569 29.3431 44 31 44V42ZM45 42H31V44H45V42ZM46 41C46 41.5523 45.5523 42 45 42V44C46.6569 44 48 42.6569 48 41H46ZM46 31V41H48V31H46ZM45 30C45.5523 30 46 30.4477 46 31H48C48 29.3431 46.6569 28 45 28V30ZM42.1997 30H45V28H42.1997V30ZM41.3251 29.4855C41.3282 29.4906 41.3312 29.4957 41.3342 29.5009L43.0652 28.4991C43.057 28.4849 43.0486 28.4707 43.0401 28.4565L41.3251 29.4855ZM40.7251 28.4855L41.3251 29.4855L43.0401 28.4565L42.4401 27.4565L40.7251 28.4855ZM39.8676 28C40.2189 28 40.5444 28.1843 40.7251 28.4855L42.4401 27.4565C41.8979 26.5529 40.9214 26 39.8676 26V28ZM36.1324 28H39.8676V26H36.1324V28Z",
    fill: "#2A2E3C",
    mask: "url(#path-6-inside-1_2222_4249)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 38,
    cy: 36,
    r: 3,
    fill: "#087E38"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M18 27.0936V38L19 38.5995V25.0001L7 18.5V20.5L17.4789 26.2157C17.8001 26.391 18 26.7277 18 27.0936Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTakeAPhoto);
export default __webpack_public_path__ + "static/media/take_a_photo.a861e4425161d63a51d960c05ed505df.svg";
export { ForwardRef as ReactComponent };